// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".Background-module__bgimage___VYQLD {\n  position: absolute; \n  width: 100%; \n  height: 100%; \n  -o-object-fit: cover; \n     object-fit: cover; \n  z-index: -10;\n}", "",{"version":3,"sources":["Background.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;EACjB,YAAY;AACd","file":"Background.module.css","sourcesContent":[".bgimage {\n  position: absolute; \n  width: 100%; \n  height: 100%; \n  object-fit: cover; \n  z-index: -10;\n}"]}]);
// Exports
exports.locals = {
	"bgimage": "Background-module__bgimage___VYQLD"
};
module.exports = exports;
